import { z } from "zod";

export const UserIdentity = z.object({
  id: z.string(),
  userId: z.string(),
});

export type UserIdentity = z.infer<typeof UserIdentity>;
